/**
 * URL Builder Utilities
 * Functions for constructing full API URLs from endpoint path strings.
 */

import { getApiConfig } from './base';

/**
 * Builds a versioned API URL: `{baseURL}/api/v1{endpoint}`
 * Used for authenticated and versioned endpoints.
 */
export const buildApiUrl = (endpoint: string): string => {
  const config = getApiConfig();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${config.baseURL}/api/${config.version}${cleanEndpoint}`;
};

/**
 * Builds a public API URL without the version segment: `{baseURL}/api{endpoint}`
 * Used for public-facing endpoints that are not versioned.
 */
export const buildPublicApiUrl = (endpoint: string): string => {
  const config = getApiConfig();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${config.baseURL}/api${cleanEndpoint}`;
};

/**
 * Normalizes an endpoint path string to always start with a leading slash.
 */
export const getEndpoint = (path: string): string => {
  return path.startsWith('/') ? path : `/${path}`;
};
